module.exports = __webpack_public_path__ + "d206ecaecffa019ede7ab31218b80e54.fbx";